import type { Immutable } from "immer";
import React from "react";

import type { ReviewsRightBarSection as ReviewsRightBarSectionValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const ReviewsRightBarSection = (
    props: Immutable<{ value: ReviewsRightBarSectionValue }>,
): React.JSX.Element => {
    const value = props.value;

    return (
        <>
            <article dangerouslySetInnerHTML={{ __html: value.header ?? "" }} />
            {(value.button ?? []).map((button, index) => (
                <div key={index} className={styles.shopNowCta}>
                    <a
                        className={concatClassNames([
                            styles.ctaButton,
                            "button",
                        ])}
                        href={button.link?.url ?? ""}
                    >
                        {button.cta_text}
                    </a>
                    {button.additional_details && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: button.additional_details,
                            }}
                        />
                    )}
                </div>
            ))}
        </>
    );
};
